// components/SearchBar.js
import React, { useState, useCallback } from "react";
import { observer } from "mobx-react-lite";
import { useContext } from "react";
import { Context } from "../index";
import { debounce } from "lodash";
import "../css/search.css";

const SearchBar = observer(() => {
  const { detail } = useContext(Context);
  const [localQuery, setLocalQuery] = useState(detail.searchQuery);

  const debouncedSearch = useCallback(
    debounce((value) => {
      detail.setSearchQuery(value);
    }, 500), // Увеличиваем задержку до 500 мс
    []
  );

  const handleChange = (e) => {
    const value = e.target.value;
    setLocalQuery(value); // Обновляем локальное состояние немедленно
    debouncedSearch(value); // Обновляем стор с задержкой
  };

  const handleClear = () => {
    setLocalQuery("");
    detail.clearSearchQuery();
  };

  const handleSearch = () => {
    debouncedSearch.flush(); // Немедленно применяем текущий запрос
    detail.setSearchQuery(localQuery);
  };

  return (
    <div className="search_container">
      <input
        type="text"
        className="search_input"
        placeholder="Поиск деталей..."
        value={localQuery}
        onChange={handleChange}
        onKeyPress={(e) => {
          if (e.key === "Enter") handleSearch();
        }}
      />
      {localQuery && (
        <button
          onClick={handleClear}
          style={{
            position: "absolute",
            right: "50px",
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 10,
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: "16px",
            color: "#000",
          }}
        >
          ✕
        </button>
      )}
      <button
        className="search_icon"
        onClick={handleSearch}
        aria-label="Искать"
      />
    </div>
  );
});

export default SearchBar;